import React from "react";
import { createRoot } from "react-dom/client";
import { HashRouter } from "./lib/router.jsx";

import App from "./App.jsx";
import { AppProvider } from "./lib/store.jsx";
import { initTelegram } from "./lib/tg.js";
import "./theme.css";

initTelegram();

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <HashRouter>
      <AppProvider>
        <App />
      </AppProvider>
    </HashRouter>
  </React.StrictMode>
);
